var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex bg-slate-100 dark:bg-slate-700 rounded-md p-1 mr-2"},_vm._l((_vm.modes),function(mode){return _c('button',{key:mode.type,class:[
      'px-3 py-1 rounded-md transition-colors flex items-center',
      _vm.modelValue === mode.type
        ? 'bg-white dark:bg-slate-600 shadow'
        : 'text-slate-500 dark:text-slate-300'
    ],attrs:{"aria-label":mode.label},on:{"click":function($event){return _vm.setMode(mode.type)}}},[_c('fluent-icon',{staticClass:"h-4 w-4",attrs:{"icon":mode.icon}}),_vm._v(" "),_c('span',{staticClass:"ml-1 text-sm hidden md:inline"},[_vm._v("\n      "+_vm._s(_vm.$t(mode.textKey))+"\n    ")])],1)}),0)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }